import ___default from "lodash";
const Common_SearchResultMessages = {
  NoResultsFound: "No results found for {text}",
  ResultFound: "{count} result found for {text}",
  ResultsFound: "{count} results found for {text}"
};
function stringFormat(str, mapping) {
  return ___default.replace(str, /\{\{|\}\}|\{(\w+)\}/g, (match, key) => {
    if (match === "{{") {
      return "{";
    }
    if (match === "}}") {
      return "}";
    }
    return mapping[key];
  });
}
const getSearchResultMessage = (searchText, items, loading) => {
  if (!searchText || loading) {
    return "";
  }
  const locStr = Common_SearchResultMessages;
  switch (items.length) {
    case 0:
      return stringFormat(locStr.NoResultsFound, { text: searchText });
    case 1:
      return stringFormat(locStr.ResultFound, { count: items.length.toLocaleString(), text: searchText });
    default:
      return stringFormat(locStr.ResultsFound, { count: items.length.toLocaleString(), text: searchText });
  }
};
export {
  getSearchResultMessage,
  stringFormat
};
//# sourceMappingURL=AnnounceSearchResults.utils.js.map
